import { render, staticRenderFns } from "./star-outlined.vue?vue&type=template&id=164c7606&"
import script from "./star-outlined.vue?vue&type=script&lang=js&"
export * from "./star-outlined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('164c7606')) {
      api.createRecord('164c7606', component.options)
    } else {
      api.reload('164c7606', component.options)
    }
    module.hot.accept("./star-outlined.vue?vue&type=template&id=164c7606&", function () {
      api.rerender('164c7606', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/star-outlined.vue"
export default component.exports